<p class="tw-m-0 tw-mt-1 tw-text-sm tw-leading-5 tw-text-slate-600 lg:tw-text-base lg:tw-leading-6" data-cy="page-subtitle">
  <ng-content></ng-content>
</p>
